{
  "processing": "सत्यापन प्रसंस्करण...",
  "loadingIframe": "ID सत्यापन लोड हो रहा है...",
  "issueTitle": "ID सत्यापन समस्या",
  "notConfigured": "इस वेयरहाउस के लिए ID सत्यापन सही तरह से कॉन्फ़िगर नहीं है।",
  "notSuccessful": "ID सत्यापन सफल नहीं रहा। कृपया पुनः प्रयास करें या वेयरहाउस से संपर्क करें।",
  "couldNotCompleteProceed": "ID सत्यापन पूरा नहीं हो सका, लेकिन आप चेक-इन के साथ आगे बढ़ सकते हैं।",
  "processFailed": "ID सत्यापन प्रसंस्करण विफल। कृपया पुनः प्रयास करें।",
  "processingFailedProceed": "ID सत्यापन प्रसंस्करण विफल रहा, लेकिन आप चेक-इन के साथ आगे बढ़ सकते हैं।",
  "genericError": "ID सत्यापन के दौरान एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
  "issueProceed": "ID सत्यापन में एक समस्या आई, लेकिन आप चेक-इन के साथ आगे बढ़ सकते हैं।",
  "requiredTryAgain": "चेक-इन पूरा करने के लिए ID सत्यापन आवश्यक है। कृपया पुनः प्रयास करें।",
  "checkInFailedTitle": "चेक-इन नहीं हो सका",
  "checkInFailedMessage": "आपकी ID सत्यापित नहीं की जा सकी"
}
